import "./style.scss";

import { Box } from "@mui/material";
import * as prismic from "@prismicio/client";
import { PrismicRichText, useAllPrismicDocumentsByType } from "@prismicio/react";
import { Spinner } from "components/shared/Spinner";
import { formatLocaleDateString } from "helpers/utils";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const ChangelogContainer = ({ portal }: { portal: string }) => {
    const [documents, { state }] = useAllPrismicDocumentsByType("changelog");
    const [t] = useTranslation();

    const changelogList = useMemo(
        () =>
            documents &&
            documents.length > 0 &&
            documents
                .filter((document) => {
                    const portalTypes = document.data.portaltypes.map(
                        (portalType: { portaltype: string }) => portalType.portaltype,
                    );
                    return portalTypes.includes(portal);
                })
                .sort(
                    (a, b) =>
                        prismic.asDate(b.last_publication_date).getTime() -
                        prismic.asDate(a.last_publication_date).getTime(),
                ),
        [documents],
    );

    return (
        <div className="changelog-container">
            {state == "loading" && (
                <Box
                    sx={{
                        display: "flex",
                        width: "100%",
                        height: "90vh",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Spinner />
                </Box>
            )}
            <h1>{t("Changelog.Changelog")}</h1>
            <p className="description">{t("Changelog.Description")}</p>
            {state == "loaded" &&
                changelogList &&
                changelogList?.map((document, i) => (
                    <div className="changelog-item" key={i}>
                        <h1 className="changelog-title">
                            {document.last_publication_date &&
                                formatLocaleDateString({
                                    date: prismic.asDate(document.last_publication_date),
                                    options: { numeric: true, timeZone: "UTC" },
                                })}
                        </h1>
                        <div className="separator"></div>
                        {/* <PrismicRichText field={document.data.title} /> */}
                        <PrismicRichText field={document.data.content} />
                    </div>
                ))}
        </div>
    );
};

export default ChangelogContainer;
